const isDesktopView = width => width === 'lg' || width === 'xl';

export default isDesktopView;
